export default __webpack_public_path__ + "static/media/hyundai.ab5efd3a.png";